// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19c80","label":"styles_label__1lJ71"};